var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 48C96 74.51 74.51 96 48 96C21.49 96 0 74.51 0 48C0 21.49 21.49 0 48 0C74.51 0 96 21.49 96 48Z",
    fill: "#019DD3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_15705",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 96
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 48C96 74.51 74.51 96 48 96C21.49 96 0 74.51 0 48C0 21.49 21.49 0 48 0C74.51 0 96 21.49 96 48Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_15705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-14.2715 77.8379H111.489V104.718H-14.2715V77.8379Z",
    fill: "#084A77"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1694 50.7495L24.6494 14.2695H71.6894L48.1694 50.7495Z",
    fill: "#98D5EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1694 36.3242L71.6894 72.8042H24.6494L48.1694 36.3242V36.3242Z",
    fill: "#98D5EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.337 51.8916L68.134 71.5336H28.541L48.337 51.8916ZM48.613 42.1286L40.216 32.4316H56.82L48.614 42.1286H48.613Z",
    fill: "#FDDA21"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5168 78.4079H21.7168C21.1408 78.4079 20.7568 78.0239 20.7568 77.4479C20.7568 74.7599 22.8688 72.6479 25.5568 72.6479H70.6768C73.3648 72.6479 75.4768 74.7599 75.4768 77.4479C75.4768 78.0239 75.0928 78.4079 74.5168 78.4079ZM23.0138 10.3789H75.8138C76.3898 10.3789 76.7738 10.7629 76.7738 11.3389C76.7738 14.0269 74.6618 16.1389 71.9738 16.1389H26.8538C24.1658 16.1389 22.0538 14.0269 22.0538 11.3389C22.0538 10.7629 22.4378 10.3789 23.0138 10.3789Z",
    fill: "#ADB4BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.54 17.9093L30.15 16.8633L38.998 34.0123L28.54 17.9093Z",
    fill: "#E2F3FC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourGlass);
export default __webpack_public_path__ + "static/media/hour-glass.c654acd8ef840660b995d3488d16416c.svg";
export { ForwardRef as ReactComponent };